import React from 'react';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { useRouter } from '@cp/shared/router';
import { introCareerIdSelector, introCatalogTypeSelector } from '@cp/entities/intro';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { useSelector } from 'react-redux';
import { useIsEmbedded } from 'src/shared/mediaQueries';
import { EmbeddingProps } from './types';

export const Embedding: React.FC<EmbeddingProps> = ({}) => {
  const isEmbedded = useIsEmbedded();
  const pathResolver = useClientWebResolver();
  const router = useRouter();
  const catalogType = useSelector(introCatalogTypeSelector);
  const careerId = useSelector(introCareerIdSelector);
  const isLoggedIn = useIsLoggedIn();

  React.useEffect(() => {
    if (isEmbedded && !isLoggedIn && (!catalogType || !careerId)) {
      router.navigate(pathResolver.resolve({ page: ClientWebPage.Intro }));
      return;
    }
  }, [careerId, catalogType, isEmbedded, isLoggedIn, pathResolver, router]);

  return null;
};
